module.exports = __webpack_public_path__ + "files/dzs6.pdf";